import React, { useState, useEffect, useContext } from "react";
import { Form, Button, message, Spin, Input, Select, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";

import api from "../../services/Api";

const Settings = () => {
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user, hasRole } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [adding, setAdding] = useState(false);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await api.getSettings();
            setSettings(response);
        } catch (error) {
            message.error("Error fetching settings");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: "Ryhmä",
            dataIndex: "category",
            key: "category",
            filters: Array.from(new Set(settings.map((setting) => setting.category))).map((category) => ({
                text: category === null ? "Ei ryhmää" : category,
                value: category,
            })),
            onFilter: (value, record) => (record.category || "")?.includes(value || ""),
            filterSearch: true,
            filterIcon: <SearchOutlined />,
        },
        {
            title: "Nimi",
            dataIndex: "label",
            key: "label",
            filters: settings.map((setting) => ({
                text: setting.label,
                value: setting.label,
            })),
            onFilter: (value, record) => (record.label || "")?.includes(value || ""),
            filterSearch: true,
            filterIcon: <SearchOutlined />,
        },
        {
            title: "Arvo",
            dataIndex: "value",
            key: "value",
            render: (value, record) => {
                if (record.type === "text") {
                    return value.substring(0, 50) + "...";
                }
                return value;
            },
        },
        {
            title: "",
            key: "actions",
            className: "text-right",
            render: (text, record) => (
                <>
                    <Link to={`/hallinta/asetukset/${record.id}`} className="mr-2">
                        <Button type="primary">Muokkaa</Button>
                    </Link>
                </>
            ),
        },
    ];

    const handleDeleteSetting = async (id) => {
        try {
            await api.deleteSetting(id);
            message.success("Asetus poistettu onnistuneesti");
            fetchSettings();
        } catch (error) {
            message.error("Virhe poistamisessa");
        }
    };

    const handleAddSetting = async (values) => {
        setAdding(true);
        try {
            await api.createSetting(values);
            message.success("Asetus lisätty onnistuneesti");
            form.resetFields();
            fetchSettings();
        } catch (error) {
            message.error("Virhe lisättäessä asetusta");
        } finally {
            setAdding(false);
        }
    };

    return (
        <div className="container max-w-screen-2xl m-auto text-lg">
            <h1 className="text-2xl mb-5">Asetukset</h1>
            {loading ? (
                <Spin />
            ) : (
                <>
                    <Table
                        size="small"
                        className="table table-striped w-full"
                        dataSource={settings}
                        columns={columns}
                        pagination={true}
                        rowKey="id"                       
                    />
                </>
            )}

            <div className="mb-8">
                <h2 className="text-lg mb-2">Lisää uusi asetus</h2>
                <Form form={form} layout="inline" onFinish={handleAddSetting} style={{ gap: 8, flexWrap: "wrap" }}>
                    <Form.Item name="category" rules={[{ required: true, message: "Anna asetuksen kategoria" }]}>
                        <Input placeholder="Ryhmä" />
                    </Form.Item>
                    <Form.Item name="label" rules={[{ required: true, message: "Anna asetuksen nimi" }]}>
                        <Input placeholder="Nimi" />
                    </Form.Item>
                    <Form.Item name="name" rules={[{ required: true, message: "Anna asetuksen avain" }]}>
                        <Input placeholder="Avain" />
                    </Form.Item>
                    <Form.Item name="type" rules={[{ required: true, message: "Valitse tyyppi" }]} initialValue="text">
                        <Select style={{ width: 120 }}>
                            <Select.Option value="text">Teksti</Select.Option>
                            <Select.Option value="number">Numero</Select.Option>
                            <Select.Option value="boolean">Kyllä/Ei</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="value" rules={[{ required: true, message: "Anna arvo" }]}>
                        <Input placeholder="Arvo" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={adding}>
                            Lisää
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default Settings;
